// frontend/src/utils/dosingUrlSync.ts
// FIX C2: Separate browser-specific code from pure codec
import debounce from 'lodash-es/debounce';
import { encodeBatchToUrl, decodeBatchFromUrl } from './dosingUrlCodec';
import type { PublicDosingBatch } from '@/types/publicDosing';

const URL_PARAM = 'b';
const DEBOUNCE_MS = 300;

function _syncBatchToUrl(batch: PublicDosingBatch | null): void {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);

  if (batch && batch.containers.length > 0) {
    const encoded = encodeBatchToUrl(batch);
    url.searchParams.set(URL_PARAM, encoded);
  } else {
    url.searchParams.delete(URL_PARAM);
  }

  window.history.replaceState({}, '', url.toString());
}

// Debounced version to prevent history spam on every keystroke
const debouncedSync = debounce(_syncBatchToUrl, DEBOUNCE_MS);

export const syncBatchToUrl = Object.assign(debouncedSync, {
  // FIX A5: Expose flush for "Copy Link" action
  flush: () => debouncedSync.flush(),
  cancel: () => debouncedSync.cancel(),
  immediate: _syncBatchToUrl, // For when you need sync now
});

/**
 * Reads batch state from current URL
 */
export function getBatchFromUrl(): PublicDosingBatch | null {
  if (typeof window === 'undefined') return null;
  const url = new URL(window.location.href);
  const encoded = url.searchParams.get(URL_PARAM);
  return encoded ? decodeBatchFromUrl(encoded) : null;
}
